export const SET_HEADING_TITLE = 'SET_HEADING_TITLE'
export const SET_HEADING_DESCRIPTION = 'SET_HEADING_DESCRIPTION'

function setHeadingTitle(state, title) {
    return {
        ...state,
        title: title,
    }
}

function setHeadingDescription(state, desc) {
    let dots = ''
    if (desc.length > 140) {
        dots = '...'
    }

    return {
        ...state,
        description: desc.substring(0, 140) + dots,
    }
}

/**
 * Reducer for heading setup
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_HEADING_TITLE: return setHeadingTitle(state, action.title)
        case SET_HEADING_DESCRIPTION: return setHeadingDescription(state, action.description)
        default: return state
    }
}
